import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FORMAS_PAGO_DOC } from "features/Crear/pages/FormCreacionDocumento/constant"
import { useTranslation } from "react-i18next"

const CardFormaPagoDocumento = ({
  values,
  setShowFormaPagoModal,
  setShowDiasPagoModal,
  colorSelected,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: $TSMigrationFixMe
  setShowFormaPagoModal: () => void
  setShowDiasPagoModal: () => void
  colorSelected: string
}) => {
  const { t } = useTranslation()
  const { formaPago, formaPagoDescription, formaPagoIban, diasPago } = values
  return (
    <div className='tw-flex tw-flex-col'>
      <div
        style={{ backgroundColor: colorSelected }}
        className='tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-h-12 tw-rounded-t-md tw-px-4 tw-text-simple-10'
      >
        {t("crear.facturaRec.paymentFormLabel")}
      </div>
      <div className='tw-flex tw-flex-col tw-px-8 tw-py-4 tw-text-left'>
        {formaPago && formaPagoDescription && (
          <p className='tw-mb-2 tw-flex tw-flex-row tw-items-center'>
            {t("crear.facturaRec.paymentFormLabel")} {formaPagoDescription}{" "}
            {formaPagoDescription && (
              <FontAwesomeIcon
                onClick={setShowFormaPagoModal}
                icon={["fal", "pen"]}
                className='tw-ml-2.5 tw-cursor-pointer tw-w-4 tw-h-4 hover:tw-text-secondary'
              />
            )}
          </p>
        )}
        {((formaPagoDescription === FORMAS_PAGO_DOC.TRANSFERENCIA &&
          formaPagoIban) ||
          (formaPagoDescription === FORMAS_PAGO_DOC.PAGO_DOMICILIADO &&
            formaPagoIban)) && (
          <p className='tw-mb-2 tw-flex tw-flex-row tw-items-center'>
            {t("crear.facturaRec.paymentFormIbanLabel", {
              iban: formaPagoIban,
            })}
          </p>
        )}
        {diasPago && (
          <p className='tw-flex tw-flex-row tw-items-center tw-mb-2'>
            {t("crear.facturaRec.paymanetDaysLabel")}
            {diasPago}
            {formaPagoDescription && (
              <FontAwesomeIcon
                onClick={setShowDiasPagoModal}
                icon={["fal", "pen"]}
                className='tw-ml-2.5 tw-cursor-pointer tw-w-4 tw-h-4 hover:tw-text-secondary'
              />
            )}
          </p>
        )}
      </div>
    </div>
  )
}

export default CardFormaPagoDocumento
